import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    IconButton
} from '@mui/material';
import { 
    Visibility as ViewIcon, 
    InboxOutlined,
    Description as DescriptionIcon,
    CheckCircle as CheckCircleIcon
} from '@mui/icons-material';
import { styles } from '../../styles/ChemoRecordsStyles';
import useChemoReportsList from '../../hooks/chemo/useChemoReportsList';

const ChemoReportsList = ({ reports, canView, onOpenReport }) => {
    const {
        hasReports,
        getStatusStyle,
        getStatusLabel,
        formatDate,
        getReportNumber,
        getCreatedBy,
        getRecordsCount
    } = useChemoReportsList(reports);

    if (!hasReports) {
        return (
            <Box sx={styles.emptyState}>
                <Box sx={styles.emptyStateIcon}>
                    <InboxOutlined style={{ fontSize: 56, color: '#adb5bd' }} />
                </Box>
                <Typography variant="h5" sx={styles.emptyStateTitle}>
                    אין דוחות זמינים
                </Typography>
                <Typography variant="body1" sx={styles.emptyStateText}>
                    הדוחות יוצגו כאן לאחר יצירתם. לחץ על "דוח חדש" כדי להתחיל
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer 
            component={Paper} 
            sx={{
                ...styles.tableContainer,
                ...styles.reportsTableContainer
            }}
        >
            <Table>
                <TableHead>
                    <TableRow sx={styles.reportsTableHeaderRow}>
                        <TableCell sx={styles.reportsTableHeaderCell}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <DescriptionIcon sx={{ fontSize: 20 }} />
                                מספר דוח
                            </Box>
                        </TableCell>
                        <TableCell sx={styles.reportsTableHeaderCell}>תאריך</TableCell>
                        <TableCell sx={styles.reportsTableHeaderCell}>נוצר על ידי</TableCell>
                        <TableCell sx={styles.reportsTableHeaderCell}>סטטוס</TableCell>
                        <TableCell sx={styles.reportsTableHeaderCell}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CheckCircleIcon sx={{ fontSize: 20 }} />
                                מספר רשומות
                            </Box>
                        </TableCell>
                        <TableCell align="center" sx={styles.reportsTableHeaderCell}>פעולות</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reports.map((report, index) => (
                        <TableRow
                            key={report.id}
                            sx={styles.reportsTableRow}
                            onClick={() => canView && onOpenReport(report)}
                        >
                            <TableCell sx={styles.reportsTableCellId}>
                                {getReportNumber(report)}
                            </TableCell>
                            <TableCell sx={styles.reportsTableCellDefault}>
                                {formatDate(report.reportDate)}
                            </TableCell>
                            <TableCell sx={styles.reportsTableCellBold}>
                                {getCreatedBy(report)}
                            </TableCell>
                            <TableCell sx={styles.reportsTableCellPadding}>
                                <Chip
                                    label={getStatusLabel(report.status)}
                                    sx={{ 
                                        ...styles.statusChip, 
                                        ...getStatusStyle(report.status)
                                    }}
                                    size="small"
                                />
                            </TableCell>
                            <TableCell sx={styles.reportsTableCellPadding}>
                                <Chip 
                                    label={getRecordsCount(report)}
                                    sx={styles.reportsCountChip}
                                    size="small"
                                />
                            </TableCell>
                            <TableCell align="center" sx={styles.reportsTableCellPadding}>
                                {canView && (
                                    <IconButton
                                        size="medium"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onOpenReport(report);
                                        }}
                                        sx={styles.reportsViewButton}
                                        title="צפייה בדוח"
                                    >
                                        <ViewIcon />
                                    </IconButton>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ChemoReportsList;
